export default "__VITE_ASSET__CCZVWMqK__"